<template>
  <div v-if="show" class="popup spinner">
    <svg class="spinner-image" width="50" height="50" viewBox="0 0 100 100">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke="#009EFF"
        stroke-width="10"
      ></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PopupSpinner',
  props: {
    opened: false,
  },
  computed: {
    show: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) {
          this.$emit('popupOff');
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.popup.spinner {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .spinner-image {
    position: relative;
    animation: rotate 2s linear infinite;
    display: flex;
    margin: auto;

    .path {
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 600;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 180, 600;
      stroke-dashoffset: -70;
    }
    100% {
      stroke-dasharray: 360, 600;
      stroke-dashoffset: -248;
    }
  }
}
</style>
